import { Routes } from '@angular/router';

import { PATHS_DICT, ROUTES_PREFIX } from './auth.constants';
import { CallbackPageComponent } from './pages/callback-page.component';
import { ErrorPageComponent } from './pages/error-page.component';
import { LoginPageComponent } from './pages/login-page.component';

/** Auth0 login flow pages, open without `adminGuard` */
export const AUTH_ROUTES: Routes = [
  {
    path: ROUTES_PREFIX,
    children: [
      {
        path: PATHS_DICT.CALLBACK,
        component: CallbackPageComponent
      },
      {
        path: PATHS_DICT.ERROR,
        component: ErrorPageComponent
      },
      {
        path: PATHS_DICT.LOGIN,
        component: LoginPageComponent
      },
      {
        path: PATHS_DICT.NO_ACCESS,
        title: 'No access',
        loadComponent: () => import('./pages/no-access-page/no-access-page.component').then(m => m.NoAccessPageComponent)
      }
    ]
  }
];
